import { useEffect, useState } from "react";
import api from "./api";

// Fetches a public site_content doc by key. Returns { data, loading } where
// `data` falls back to the supplied default when key is missing/empty.
export default function useContent(key, fallback) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let mounted = true;
    api.get(`/site/content/${key}`).then((r) => {
      if (!mounted) return;
      const doc = r.data || {};
      // Treat as "set" only if it actually contains usable fields beyond key/title/body
      const hasItems = Array.isArray(doc.items) && doc.items.length > 0;
      const hasBlocks = Array.isArray(doc.blocks) && doc.blocks.length > 0;
      if (hasItems || hasBlocks) {
        setData(doc);
      } else {
        setData(fallback);
      }
    }).catch(() => setData(fallback)).finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [key]);
  return { data, loading };
}
